/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportContactCompaniesV2MutationRequest,
  ExportContactCompaniesV2MutationResponse,
  ExportContactCompaniesV2400,
  ExportContactCompaniesV2500,
} from '../types/ExportContactCompaniesV2'

function getExportContactCompaniesV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/contacts/contactcompanies/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async contact companies export.
 * @summary Start an async chains (contact companies) export
 * {@link /api/v1/contacts/contactcompanies/export/v2/}
 */
export async function exportContactCompaniesV2(
  data: ExportContactCompaniesV2MutationRequest,
  config: Partial<RequestConfig<ExportContactCompaniesV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportContactCompaniesV2MutationResponse,
    ResponseErrorConfig<
      ExportContactCompaniesV2400 | ExportContactCompaniesV2500
    >,
    ExportContactCompaniesV2MutationRequest
  >({
    method: 'POST',
    url: getExportContactCompaniesV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
